import { render, staticRenderFns } from "./NextStepsTab.vue?vue&type=template&id=a4ce4ae0&scoped=true"
import script from "./NextStepsTab.vue?vue&type=script&lang=ts"
export * from "./NextStepsTab.vue?vue&type=script&lang=ts"
import style0 from "./NextStepsTab.vue?vue&type=style&index=0&id=a4ce4ae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ce4ae0",
  null
  
)

export default component.exports